import { baseApi } from 'app/services/baseApi';
import { LoginInformation } from './authSlice';

export interface Credentials {
  email: string;
  password: string;
}

export interface LoginResponse {
  data: LoginInformation;
  message: string;
}

export const authApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getProfile: builder.query({
      query: () => ({
        url: 'user/self?include=["profile"]',
        method: 'GET',
      }),
    }),

    login: builder.mutation({
      query: (credentials: Credentials) => ({
        url: '/emailauth/login',
        method: 'POST',
        body: { ...credentials },
      }),
      transformResponse(response: LoginResponse, _meta, _arg) {
        const { refresh_token, user } = response.data;
        localStorage.setItem('refreshToken', refresh_token.token);
        localStorage.setItem('accessToken', response.data.token);

        return {
          user,
          refreshToken: refresh_token,
          accessToken: {
            token: response.data.token,
            expires: response.data.expires,
          },
        };
      },
    }),

    authExchange: builder.mutation({
      query: (token: string) => ({
        url: '/emailauth/exchange',
        method: 'POST',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }),
      transformResponse(response: LoginResponse, _meta, _arg) {
        const { refresh_token, user } = response.data;
        localStorage.setItem('refreshToken', refresh_token.token);
        localStorage.setItem('accessToken', response.data.token);

        return {
          user,
          refreshToken: refresh_token,
          accessToken: {
            token: response.data.token,
            expires: response.data.expires,
          },
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const { useGetProfileQuery, useLazyGetProfileQuery, useLoginMutation, useAuthExchangeMutation } = authApi;
